import { Button } from "reactstrap";
import { logoutButtonStyles } from "../styles/mainStyles";

function LogoutButton({ onClick, title, size = "lg" }) {
    return (
        <>
            <Button
                onClick={onClick}
                style={logoutButtonStyles}
                size={size}
                onMouseOver={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
                }
                onMouseOut={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
                }
            >
                <i className="fas fa-sign-out-alt"></i> {title}
            </Button>
        </>
    );
}

export default LogoutButton;
